import React from "react";
import { businessCategories } from "../Home/BusinessCategories";
import Card from "../../components/common/ReviewCard/Card";
import Heading from "../../components/common/Typography/Heading";
import MovingLeft from "../../components/common/FullLengthSwipers/MovingLeft";
import MovingRight from "../../components/common/FullLengthSwipers/MovingRight";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_SWIPER_CARD_MARGIN_CLASS,
} from "../Public/shared/publicLayoutSpec";

const SatisfiedClients = () => {
  return (
    <>
      <div className={`mx-[5%] xl:mx-auto xl:w-[1100px] 2xl:w-[1264px] ${PUBLIC_SECTION_GAP_CLASS}`}>
        <Heading variant={"h2"} className={"text-start text-offblack"}>
        Customer reviews and experiences
        </Heading>
      </div>
      <div className={PUBLIC_HEADING_TO_CONTENT_CLASS}>
        <MovingLeft speed={"300s"}>
          {businessCategories
            .sort((a, b) =>
              a.businessCategoryName.localeCompare(b.businessCategoryName)
            )
            .map((item, index) => (
              <div className="sliderImg" key={index}>
                <div className={`cursor-pointer ${PUBLIC_SWIPER_CARD_MARGIN_CLASS}`}>
                  <Card noBorder={true} />
                </div>
              </div>
            ))}
        </MovingLeft>
        <MovingRight speed={"300s"}>
          {businessCategories
            .sort((a, b) =>
              a.businessCategoryName.localeCompare(b.businessCategoryName)
            )
            .map((item, index) => (
              <div className="sliderImg" key={index}>
                <div className={`cursor-pointer ${PUBLIC_SWIPER_CARD_MARGIN_CLASS}`}>
                  <Card noBorder={true} />
                </div>
              </div>
            ))}
        </MovingRight>
      </div>
    </>
  );
};

export default SatisfiedClients;
